/**
 * Vite build-time env, behind a module seam.
 *
 * `import.meta` doesn't compile under the jest ts config, so any module reading it directly drags that
 * failure through every importer — a component three levels up becomes untestable because something in
 * its import graph touched `import.meta.env`. Reading it here (with a `__mocks__` sibling) keeps that
 * contained to one file. Prefer importing from this module over `import.meta.env`.
 */
export const X_API_KEY: string = import.meta.env.VITE_X_API_KEY ?? '';

export const DEV: boolean = import.meta.env.DEV ?? false;
